import { useState } from "react";

const PasswordLoginCard = ({
  title,
  icon,
  onSubmit,
  forgotPasswordHref,
  otpRequired = false,
  maskedEmail = "",
  onCancelOtp,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-6">
      <form onSubmit={onSubmit} className="flex h-full flex-col">
        <div className="mb-5 flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded bg-gray-100 text-gray-700">
            <i className={`fas ${icon}`}></i>
          </span>
          <h3 className="text-lg font-bold text-gray-800">{title}</h3>
        </div>
        {otpRequired ? (
          <>
            {/* Hidden anti-autofill fields */}
            <input
              type="text"
              name="fake_username"
              autoComplete="username"
              style={{ display: "none" }}
            />

            <input
              type="password"
              name="fake_password"
              autoComplete="new-password"
              style={{ display: "none" }}
            />
            <p className="mb-4 text-sm text-gray-600">
              Enter the verification code sent to {maskedEmail}.
            </p>
            <div className="mb-3">
              <label className="mb-2 block text-sm font-bold text-gray-700">
                Verification Code
              </label>
              <input
                type="text"
                name="verification_code"
                inputMode="numeric"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                data-lpignore="true"
                data-form-type="other"
                className="w-full rounded border px-3 py-2 text-gray-700 shadow focus:outline-none focus:shadow-outline"
                placeholder="Enter 6-digit code"
                maxLength={6}
              />
            </div>
          </>
        ) : (
          <>
            <div className="mb-4">
              <label className="mb-2 block text-sm font-bold text-gray-700">
                Username (Registered email)
              </label>
              <input
                type="text"
                name="username"
                className="w-full rounded border px-3 py-2 text-gray-700 shadow focus:outline-none focus:shadow-outline"
                placeholder="Enter your registered email"
              />
            </div>
            <div className="mb-3">
              <label className="mb-2 block text-sm font-bold text-gray-700">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="w-full rounded border px-3 py-2 pr-10 text-gray-700 shadow focus:outline-none focus:shadow-outline"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((value) => !value)}
                  className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-gray-700"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <i
                    className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  ></i>
                </button>
              </div>
            </div>
          </>
        )}
        <div className="mt-auto flex items-center gap-4">
          {otpRequired ? (
            <button
              type="button"
              onClick={onCancelOtp}
              className="w-1/2 text-sm font-semibold text-blue-600 hover:text-blue-800"
            >
              Back to Login
            </button>
          ) : (
            forgotPasswordHref && (
              <a
                href={forgotPasswordHref}
                className="w-1/2 text-sm font-semibold text-blue-600 hover:text-blue-800"
              >
                Forgot Password?
              </a>
            )
          )}
          <button
            type="submit"
            className={`btn rounded px-4 py-2 font-bold text-white ${
              forgotPasswordHref || otpRequired ? "w-1/2" : "w-full"
            }`}
          >
            {otpRequired ? "Verify" : "Login"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PasswordLoginCard;
